module.exports = __webpack_public_path__ + "img/stacked-bar-icon-white.6062ee92.svg";